export const SITE_URL = 'https://musiqueprete.teachready.shop/'

export const SITE_TITLE = 'MUSIQUE PRÊTE | 10 tomes et 5 bonus pour enseigner la musique'

export const SITE_DESCRIPTION =
  'Une collection en français de 10 tomes et 5 bonus\u00A0: activités, fiches élèves, cartes, projets et outils d’évaluation pour enseigner la musique.'

/** Real product mockup (10 tomes + 5 bonus), 1254 × 1254 px. */
export const HERO_MOCKUP = {
  src: 'https://cdn.magicpatterns.com/uploads/3W2vB3irKoi96A9QdzH7c1/Imagen_de_Codex_27_sept_2026,_10_42_41_a.m..png',
  width: 1254,
  height: 1254,
  alt: 'Illustration de la collection numérique MUSIQUE PRÊTE\u00A0: les 10 tomes et les 5 bonus, présentés comme livres et sur écran',
}
